// extracted by mini-css-extract-plugin
module.exports = {"container":"_9zB9Q","forumContainer":"_158OE","divider":"dQBzi"};